var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4djm5h4c8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8882",
    style: {
      fill: "#7833ba"
    },
    d: "M0 0h18.902v19.291H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-265 -550)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8885",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(265 550)",
    style: {
      fill: "#e8cfff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9297"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9296",
    transform: "translate(276 560)",
    style: {
      clipPath: "url(#4djm5h4c8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37099",
    d: "M20.064 5.321a8.357 8.357 0 0 1 1.6-2.3 9.623 9.623 0 0 1 13.273-.678c.145.125.18.2.023.351-.808.791-1.6 1.6-2.4 2.395-.082.082-.137.182-.283.048a5.54 5.54 0 0 0-7.447.163 6.151 6.151 0 0 0-1.6 2.442c-.05-.033-.1-.062-.15-.1l-3.016-2.321",
    transform: "translate(-19.024)",
    style: {
      fillRule: "evenodd",
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37100",
    d: "M23.061 222.194a6.461 6.461 0 0 0 1.181 2.017 5.676 5.676 0 0 0 5.053 1.935 6.115 6.115 0 0 0 2.586-.9c.076.068.149.141.23.2l2.8 2.182A8.017 8.017 0 0 1 31.3 229.6a9.713 9.713 0 0 1-8.834-1.782 8.956 8.956 0 0 1-2.554-3.183l3.15-2.445",
    transform: "translate(-18.879 -210.682)",
    style: {
      fillRule: "evenodd",
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37101",
    d: "m192.117 160.115-2.8-2.182c-.081-.063-.153-.136-.23-.2a4.9 4.9 0 0 0 1.506-1.778 6.18 6.18 0 0 0 .327-.9c.063-.211.044-.293-.217-.291-1.554.013-3.107.007-4.661.006-.329 0-.329 0-.329-.34 0-1.053.005-2.106 0-3.159 0-.2.034-.281.262-.28q4.3.013 8.6 0c.155 0 .252.011.279.2a10.576 10.576 0 0 1-1.241 7.114 7.1 7.1 0 0 1-1.488 1.81",
    transform: "translate(-176.086 -143.166)",
    style: {
      fillRule: "evenodd",
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 37102",
    d: "m4.182 108.885-3.15 2.445a8.725 8.725 0 0 1-.946-3.044 9.531 9.531 0 0 1 .808-5.322c.043-.093.1-.181.147-.271l3.016 2.322c.047.036.1.065.15.1a6.093 6.093 0 0 0-.024 3.771",
    transform: "translate(0 -97.372)",
    style: {
      fillRule: "evenodd",
      fill: "#7833ba"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGmail);
export default __webpack_public_path__ + "static/media/login_gmail.e88501296c98ae0ebe4a65eb8f3f1f8e.svg";
export { ForwardRef as ReactComponent };